import {UI} from "../../../../stem-core/ui/UIBase";

import {styleRule, styleRuleInherit} from "../../../../stem-core/ui/Style";
import {registerStyle} from "../../../../stem-core/ui/style/Theme";
import {WalletCard, WalletCardStyle} from "../../ui/WalletCard";
import {PaymentMethod} from "../../../State";
import {Messages} from "../../../Messages";
import {BlinkButton} from "../../../../core/ui/Button.jsx";
import {WalletPopup} from "../../ui/WalletPopup";
import {WidgetRoutes} from "../../WidgetRoutes";
import {WALLET_CARD_CONTENT_HEIGHT} from "../../WidgetConstants";
import {PaymentMethodSelectInput} from "../../../panel/pages/panels/payment-method/components/PaymentMethodSelectInput.jsx";
import {Router} from "../../../../stem-core/ui/Router";
import {apiSetPrimaryPaymentMethod} from "../../../../client/state/PaymentMethodStore";
import {wrapInSpinner} from "../../../../core/ui/LoadingSpinner.jsx";


class ElementStyle extends WalletCardStyle {
    @styleRuleInherit
    container = {
        padding: "24px 0",
        minHeight: 0,
    };

    @styleRuleInherit
    content = {
        display: "flex",
        flexDirection: "column",
        height: WALLET_CARD_CONTENT_HEIGHT,
        padding: "0 24px",
    };

    @styleRule
    chooseCardContainer = {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    };
}

@registerStyle(ElementStyle)
export class WidgetChooseCardClass extends WalletCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.choosePaymentMethod,
        };
    }

    render() {
        const {styleSheet} = this;

        return <PaymentMethodSelectInput
            ref="chooseCard"
            className={styleSheet.chooseCardContainer}
            onAddCard={() => this.onAddCardClick()}
            onChange={() => this.redraw()}
        />;
    }

    onAddCardClick() {
        Router.changeURL(WidgetRoutes.ADD_CARD);
    }

    renderPrimaryButton() {
        return <BlinkButton
            testId="chooseCardButton"
            disabled={this.chooseCard?.getValue() === PaymentMethod.getPrimary()}
            onClick={() => this.onPrimaryButtonClick()}
            label={Messages.continue}
        />;
    }

    @wrapInSpinner
    async onPrimaryButtonClick() {
        await apiSetPrimaryPaymentMethod(this.chooseCard.getValue()?.id);
        Router.back();
    }
}

export const WidgetChooseCard = WalletPopup(WidgetChooseCardClass);
